import { Either } from "fp-ts/lib/Either";
import ServiceEntity from "../../../domain/entities/ServiceEntity";
import { getServiceByIdApiImpl } from "./api/GetServiceByIdApiImpl";
import { requestCarPickupApiImpl } from "./api/RequestCarPickupApiImpl";
import { acceptTyCApiImpl } from "./api/AcceptTermsAndConditionsApiImpl";
import ServiceRepository from "../../../domain/repositories/ServiceRepository";

export default class ServiceRepositoryImpl extends ServiceRepository {
  getServiceById = (id: string): Promise<Either<string, ServiceEntity>> => getServiceByIdApiImpl(id);
  requestCarPickup = (serviceId: string): Promise<Either<string, void>> => requestCarPickupApiImpl(serviceId);
  acceptTermsAndConditions = (serviceId: string): Promise<Either<string, void>> => acceptTyCApiImpl(serviceId);
}